var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogosJira(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1025_46335)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.6137 0H16.4746C16.4746 1.95501 17.2422 3.82994 18.6085 5.21234C19.9748 6.59474 21.8278 7.37136 23.7601 7.37136H26.7331V10.2757C26.7357 14.3431 29.9938 17.6398 34.0138 17.6424V1.41658C34.0138 0.634445 33.3871 0 32.6137 0Z",
    fill: "#2684FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6273 8.13672H8.48828C8.49078 12.2041 11.7489 15.5008 15.769 15.5034H18.742V18.4171C18.7471 22.4845 22.0075 25.7789 26.0275 25.7789V9.55356C26.0275 8.77116 25.4006 8.13685 24.6273 8.13685V8.13672Z",
    fill: "url(#paint0_linear_1025_46335)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6372 16.2676H0.498047C0.498047 20.3387 3.75997 23.6389 7.7835 23.6389H10.7658V26.5431C10.7685 30.6068 14.0209 33.902 18.0374 33.9097V17.6843C18.0374 16.9019 17.4104 16.2676 16.6372 16.2676Z",
    fill: "url(#paint1_linear_1025_46335)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1025_46335",
    x1: 25.6821,
    y1: 8.16512,
    x2: 18.7751,
    y2: 15.2883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1025_46335",
    x1: 18.154,
    y1: 16.3478,
    x2: 10.1698,
    y2: 24.1117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1025_46335"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.6038,
    height: 34,
    fill: "white",
    transform: "translate(0.498047)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosJira);
export default __webpack_public_path__ + "static/media/logos_jira.7695c7b7b3169fa34f5b584907a1529c.svg";
export { ForwardRef as ReactComponent };